import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';
import { unwrapElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { type CalendarDateRequired } from '#utils/UNSAFE_calendarDateUtils';

export class DatePickerAdapter extends TestAdapter {
  /**
   * Change and commit the value of the component.
   * @param value {CalendarDateRequired} The new value.
   * @returns Promise<void>
   */
  async changeValue(value: CalendarDateRequired) {
    const driver = this.getTestDriver();
    const el = await this.getElement();
    // executeScript can only consume local variables.
    const newValue = value;

    // For now, unwrap the TestElement to get the underlying DOM element until JET-73740 is fixed.
    await driver.executeScript(
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      (el: any, newValue: CalendarDateRequired) => el._changeValue(newValue),
      unwrapElement(el),
      newValue
    );
  }
}
